module.exports = __webpack_public_path__ + "d67560eb.png";